import { createSystem, defaultConfig } from '@chakra-ui/react';

const system = createSystem(defaultConfig, {
  globalCss: {
    body: {
      bg: 'gray.50',
      color: 'gray.800'
    }
  },
  theme: {
    tokens: {
      fonts: {
        heading: { value: 'Inter, Segoe UI, system-ui, sans-serif' },
        body: { value: 'Inter, Segoe UI, system-ui, sans-serif' }
      }
    }
  }
});

export default system;
